/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
/**
 * Navigator base class for reacting to 'pan' input events.
 */
export class BasePanNavigator {
    constructor(cam, el, speed = 1) {
        this.allowPanDuringPinch = false;
        this.allowPanOnlyAtPinch = false;
        /**
         * Restrict pan navigator to a specific mouse buttons.
         * `0` is *left*, `1` is *middle* and `2` is *right* mouse button.
         */
        this.allowedMouseBtns = [0];
        this._enabled = true;
        this._onPan = (event) => {
            if (this._enabled) {
                const { isPinch, mouseBtn } = event.detail;
                const { allowPanDuringPinch, allowPanOnlyAtPinch, allowedMouseBtns } = this;
                let allowPan;
                if (isPinch) {
                    allowPan = allowPanDuringPinch;
                }
                else {
                    if (mouseBtn === -1 && allowPanOnlyAtPinch) {
                        allowPan = false;
                    }
                    else {
                        allowPan = allowedMouseBtns.indexOf(mouseBtn) >= 0;
                    }
                }
                if (allowPan) {
                    this.pan(event);
                }
            }
        };
        this._cam = cam;
        this.speed = speed;
        const eventListenerOptions = { passive: true }; // edge and ie11 need identical options to match
        // listener for removal
        el.addEventListener('pan', this._onPan, eventListenerOptions);
        this.dispose = (() => {
            // @ts-ignore
            el.removeEventListener('pan', this._onPan, eventListenerOptions);
        });
    }
    // tslint:disable-next-line:no-empty
    update() {
    }
    enable(enable) {
        this._enabled = enable;
    }
    pan(_event) {
        // nothing to do here, please override
    }
}
//# sourceMappingURL=BasePanNavigator.js.map